import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../lib/components';
import {TimeZoneComponentStore} from '../TimeZoneComponentStore';

@observer
export class DeleteTimeZoneControls extends React.Component<{ store: TimeZoneComponentStore }> {
  render() {
    const store = this.props.store;

    if (store.deleteTimeZone === null)
      return null;

    const deleteTimeZone = store.deleteTimeZone;
    const isFailure = deleteTimeZone.save?.isRejected === true;
    return (<>
      <PromiseMessage label="Deleting time zone" state={deleteTimeZone.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={store.completeDelete}>
              Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}>
              Cancel
            </button>
          </div>
        </div>
      }

    </>);
  }
}
